export default {
    filtro: {
        periodo_padrao: 'Período padrão',
        periodo_personalizado: 'Período personalizado',
        mais_filtros: 'Mais Filtros',
        vns: 'VNS',
        recipiente: 'Recipiente/ID',
        empresa: 'Empresa',
        paciente: 'Paciente',
        tipo_integracao: 'Tipo de Integração',
        status: 'Status',
        status_filtro: {
            todos: 'Todos',
            novo: 'Novo',
            ativo: 'Online',
            desconectado: 'Desconectado',
            analise: 'Em Análise',
            offline: 'Offline'
        },
        erros: {
            label: 'Erros',
            dexpara: 'Todos os erros de dexpara',
            exame: 'Erros de dexpara de exame',
            metodo: 'Erros de dexpara de método',
            material: 'Erros de dexpara de material'
        },
        filtrar_button: 'Filtrar',
        limpar_button: 'Limpar Filtros'
    },
    automacao: {
        titulo: 'Ordens e Resultados',
        ordens: 'Ordens',
        resultados: 'Resultados'
    },
    link: {
        titulo: 'Ordens e Resultados - Apoio',
        ordens: 'Ordens',
        resultados: 'Resultados',
        numero_pedido: 'Número do Pedido'
    },
    lis: {
        titulo: 'Ordens e Resultados - Lis'
    },
    periodos: {
        trinta_minutos: '30 minutos atrás',
        uma_hora: '1 hora atrás',
        hoje: 'Hoje',
        sete_dias: 'Últimos 7 dias',
        mes_atual: 'Mês atual',
        mes_anterior: 'Mês anterior',
        ano_atual: 'Ano atual',
        ano_anterior: 'Ano anterior'
    },
    messages:{
        resend: {
            success: 'Reenvio feito com Sucesso!',
            error: 'Erro ao reenviar!',
            recipient_diference: 'Para reenviar o resultado, o número do recipiente deve ser diferente do original!',
            reason_required: 'Por favor, preencha o motivo da alteração do recipiente!'
        },
        reprint: {
            success: 'Impressão realizada!',
            error: 'Erro ao reeprimir etiqueta!'
        },
        file_not_found: 'Arquivo não encontrado!',
        file_error: 'Erro ao ler arquivo!',
        getObservation: {
            success: 'Os resultados serão solicitados ao Lab. de Apoio!',
            error: 'Erro ao buscar resultados!'
        }
    },
    table: {
        fields: {
            recipiente: 'Recipiente/ID',
            informacoes: 'Informações',
            vns: 'VNS',
            empresa: 'Empresa',
            paciente: 'Paciente',
            ultima_atualizacao: 'Última atualização',
            acoes: 'Ações'
        },
        status: {
            ordem_recebida: 'Ordem Recebida',
            no_equipamento: 'Processado no EQPT',
            resultados: 'Resultado Enviado',
            completos: 'Resultados completos',
            erro_dexpara: 'Erro no De X Para',
            erro_suporte: 'Erro no Suporte / Origem',
        }
    },
    modal: {
        titulo: 'Exames',
        reenviar_ordem: 'Reenviar Ordem',
        reenviar_resultado: 'Reenviar Resultado',
        reemprimir_etiqueta: 'Reemprimir Etiqueta',
        dados: 'Dados',
        arquivo: 'Arquivo',
        lis_bruto: 'LIS bruto',
        lis_formatado: 'LIS formatado',
        vns_bruto: 'VNS bruto',
        vns_formatado: 'VNS formatado',
        table: {
            recipiente: 'Recipiente/ID',
            paciente: 'Paciente',
            athlete: 'Atleta/ID',
            horario: 'Horário',
            exame_lis: 'Exame LIS',
            exame_vns: 'Exame Integração',
            status: 'Status',
            acoes: 'Ações',
            erro: 'Erro'
        },
        details: {
            ordem_exam_code_lis: 'Ordem LIS',
            ordem_exam_code_vns: 'Ordem da Integração',
            resultado_exam_code_lis: 'Resultado LIS',
            resultado_exam_code_vns: 'Resultado da Integração',
            metodo_origem: 'Método origem',
            metodo_destino: 'Método destino',
            valor: 'Valor',
            unidade: 'Unidade',
            texto_referencia: 'Texto referência',
            estrutura_referencia: 'Estrutura referência',
            tipo_resultado: 'Tipo de Resultado',
            tipo_resultado_decimal: 'Decimal',
            tipo_resultado_alfanumerico: 'Alfanumérico',
            processado: 'Processado em',
            status_protocolo: 'Status do Protocolo',
            motivo_revisao: 'Motivo da Revisão de Resultado',
            usuario_revisao: 'Usuário que revisou o resultado',
            protocolo_status: {
                available: 'Disponível',
                blocked: 'Bloqueado',
                review: 'Em Revisão',
                reviewed: 'Revisado',
                sent: 'Enviado',
                canceled: 'Cancelado'
            },
            mapping: {
                exam_originCode: 'Exame LIS',
                exam_destinationCode: 'Exame da Integração',
                specimen_originCode: 'Material LIS',
                specimen_destinationCode: 'Material da Integração',
                method_originCode: 'Metodo LIS',
                method_destinationCode: 'Metodo da Integração',
                parent_exam_originCode: 'Exame pai LIS',
                parent_exam_destinationCode: 'Exame pai da Integração'
            },
            exame_lis: 'Exame Origem',
            exame: 'Exame',
            origem: 'Origem',
            destino: 'Destino',
            material_lis: 'Material Origem',
            material: 'Material',
            numero_pedido: 'Número do Pedido',
            metodo: 'Método',
            material_adicional: 'Material Adicional',
            complemento_material_lis: 'Complemento Origem',
            complemento_material: 'Complemento Destino',
            especie: 'Espécie',
            raca: 'Raça',
            pelagem: 'Pelagem',
            porte: 'Porte',
            exames: 'Exames',
            complementos_exames: 'Complementos de Exames',
            controle_qualidade: 'Controle de Qualidade',
            pet: 'Pet',
            erros_suporte: 'Erros do Suporte',
            erros_origem: 'Erros da Origem',
            mensagem: 'Mensagem',
            data_hora: 'Data e Hora',
            protocolo: 'Protocolo',
            editar_recipiente: 'Editar Recipiente',
            recipiente_alterado: 'Recipiente Alterado',            
            recipientes_reenviados: 'Recipientes Reenviados',
            novo_recipiente: 'Novo Recipiente',
            vs_usuario_id: 'VS Usuário ID',
            vs_usuario_name: 'VS Usuário Nome',
            criado_em: 'Criado Em',
            motivo: 'Motivo',
            resend: {
                change_recipient: "Altere o número do recipiente e reenvie o resultado do exame:",
                fix_recipient_number: "Corrija o número do recipiente:",
                fix_recipient_number_placeholder: "digite o novo número do recipiente",
                edit_reason: "Motivo da Alteração:",
                edit_reason_placeholder: "Informe o motivo ...",
                resend_result: "Reenviar Resultado"
            },
            changed: {
                original_recipient: "Recipiente Original:",
                user_id: "ID do Usuário:",
                user_name: "Nome do Usuário:",
                reason: "Motivo:"
            }
        },
        getObservation :{
            pending: 'Buscar resultados pendentes',
            all: 'Buscar e reenviar todos os resultados'
        },
        file_detail: {
            empty: 'Nenhum arquivo encontrado!',
            reenviar_arquivo: 'Reenviar arquivo',
            arquivo: 'Arquivo',
            etapa: 'Etapa',
            reenviar: 'Reenviar'
        },
        recipiente: {
            exames: 'Exames',
            horario: 'Horário',
            arquivos: 'Arquivos',
            status: 'Status',
            acoes: 'Ações',
            resultado: 'Resultado',
            ordem: 'Ordem',
            carregando_ordens: 'Carregando Ordens',
            carregando_resultados: 'Carregando Resultados'
        },
        report_result_detail: {
            resultado: 'Resultado',
            inconclusivo: 'Inconclusivo',
            reagente: 'Reagente',
            nao_reagente: 'Não reagente',
            enviar_resultados: 'Enviar Resultado(s)',
            informe_resultado_exame: 'Informe o resultado para o Exame:',
            exame: 'Exame:',
            sem_de_para: 'não possui De X Para para integração de destino no momento desta ordem',
            resultado_recebido: 'Resultado recebido com Sucesso!',
            erro_transmitir_resultado: 'Erro ao Transmitir Resultado, verifique o console!'
        }
    }
}
